import { ActionFunction } from '../interface/action/action-function.type';
import { ActionEnum } from '../enum/action.enum';
import { IRoutePayload } from '../interface/action/route-payload.interface';
import { manageEditor } from '../util/action/type/manage-editor-action.util';
import { AjaxResponse } from 'rxjs/Rx';
import { noop } from '../util/action/type/noop-action.util';
import { action } from 'mobx';
import { invariant } from '../util/debug/invariant.util';
import { replacePage } from '../util/action/type/replace-page.util';
import { loadCustomListDefinitions } from '../util/action/type/load-custom-list-definitions-action.util';

export const loadAdminRoute$: ActionFunction<IRoutePayload> = (action$, {state}) => {
  return action$
    .type(ActionEnum.LOAD_ADMIN_ROUTE)
    .map(action(() => {
      const returnActions = [ manageEditor(), loadCustomListDefinitions() ];
      if (state.configuration.debug && state.configuration.debugCMSUrl) {
        returnActions.push(replacePage('/error'));
        invariant(false, 'You can\'t access the admin when debugging on a different url then the original app url');
      }
      state.configuration.inAdmin = true;
      return returnActions;
    }));
};

export const loadRoles$: ActionFunction = (action$, {state, service}) => {
  return action$
    .type(ActionEnum.LOAD_ROLES)
    .switchMap(action(() => {
      state.isLoading = true;
      return service.systemService.getAllRoles()
        .map(action((response: AjaxResponse) => {
          if (response.status === 200) {
            state.systemRoles = response.response.roles;
          }
          state.isLoading = false;
          return noop();
        }));
    }));
};

export const loadPublicRoute$: ActionFunction<IRoutePayload> = (action$, {state}) => {
  return action$
    .type(ActionEnum.LOAD_PUBLIC_ROUTE)
    .end(action(() => {
      state.configuration.inAdmin = false;
    }));
};

export default {
  actions: [ loadAdminRoute$, loadPublicRoute$, loadRoles$ ]
};
